import { lazy, useEffect } from "react";
import { Suspense } from "react";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import Layout from "./routes/Layout";
import PrivateRoute from "./routes/PrivateRoute";
import { routes } from "./routes/_routes";
import "aos/dist/aos.css";
import Aos from "aos";
import { Navigate } from "react-router-dom";
import { initApp, initInsuranceApp } from "./store/auth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DetailTransactionsForCheck from "./views/detailTransaction/DetailTransactionsForCheck";
import useCategories from "./store/categories";
import { api } from "./helpers/api";
const mode = process.env.NODE_ENV;

// import Pages
const Login = lazy(() => import("./views/auth/Login"));
const DetailTransaction = lazy(() =>
  import("./views/detailTransaction/DetailTransaction")
);
const DetailTransactionR = lazy(() =>
  import("./views/detailTransaction/DetailTransactionR")
);
const DetailTransactionForSelf = lazy(() =>
  import("./views/detailTransaction/DetailTransactionForSelf")
);
const NotFound = lazy(() => import("./views/notfound/NotFound"));

const loading = <LinearProgress />;

function RootRedirect({ categories }) {
  const navigate = useNavigate();
  const { fetchCategories } = useCategories();
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log(error);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("worldPayToken");
        navigate("/login");
      }
      return Promise.reject(error);
    }
  );

  useEffect(() => {
    if (categories?.length > 0) {
      navigate(`/dashboard/vendors-by-category/${categories[0].id}`, {
        replace: true,
      });
    }
    console.log("/");
  }, [categories, navigate]);
  useEffect(() => {
    fetchCategories().then((res) => console.log(res));
  }, []);

  return null;
}

const App = () => {
  initApp();
  initInsuranceApp();
  window.addEventListener("load", () => {
    Aos.init();
  });
  const { categories } = useCategories();

  console.log(`This is a ${mode} mode`);

  return (
    <BrowserRouter>
      {/* <Index /> */}
      <ToastContainer position="top-right" />
      <Suspense fallback={loading}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard/receipt/:id"
            element={<DetailTransaction />}
          />
          <Route
            path="/dashboard/transactions/for-check"
            element={<DetailTransactionsForCheck />}
          />
          <Route
            path="/dashboard/transaction/f4d5b76a2418eba4baeabc1ed9142b54/:id"
            element={<DetailTransactionForSelf />}
          />
          <Route
            // path="/dashboard/r/1698907969/2009643323443"
            // path="/dashboard/r/:time/:transaction_id"
            path="/d/r/:transaction_id"
            element={<DetailTransactionR />}
          />
          {/* r/created_at/transaction_id */}

          <Route path="*" element={<NotFound />} />
          {routes?.map(({ path, element: Component, exact }, idx) => (
            <Route
              key={idx}
              path={path}
              exact={exact}
              element={
                <PrivateRoute>
                  <Layout>
                    <Component />
                  </Layout>
                </PrivateRoute>
              }
            />
          ))}

          <Route path="/" element={<RootRedirect categories={categories} />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
